/** biome-ignore-all lint/complexity/noExcessiveLinesPerFunction: TODO: disable this rule */
import { valueToNumber, valueToString } from '@/utilz';

import type { EarlyShipmentRestrictionDetails, TMSSettingsApi } from '../../models';

const formatCargoTypeRestrictions = (restrictions: EarlyShipmentRestrictionDetails[] = []) => {
  // TODO: Rest types may only be created from object types.ts(2700)
  // @ts-expect-error
  const restrictionsPrepared = restrictions.map(({ isNew, id, ...item }) => ({
    cargoType: item.cargoType,
    customerKey: item.customerKey,
    maximumDays: Number(item.maximumDays),
    maximumDaysError: item.maximumDaysError,
    ...(!isNew ? { id } : {}),
  }));

  return restrictionsPrepared;
};

export const normalizeTmsSettingsUpdate = (data: TMSSettingsApi): TMSSettingsApi => {
  if (data) {
    const newSettings: TMSSettingsApi = {
      ...data,
      adminEmail: valueToString(data.adminEmail),
      allowDraftShipments: data.allowDraftShipments,
      autoRate: data.autoRate,
      autoTender: data.autoTender || null,
      autoTenderAmount: valueToNumber(data.autoTenderAmount),
      autoTenderCargoType: valueToString(data.autoTenderCargoType),
      bidExpiryNoOfDays: valueToNumber(data.bidExpiryNoOfDays),
      brokerageCustomer: data.brokerageCustomer,
      defaultBranchKey: valueToNumber(data.defaultBranchKey),
      defaultBusinessJustification: valueToString(data.defaultBusinessJustification),
      defaultCargoType: valueToString(data.defaultCargoType),
      defaultClass: valueToString(data.defaultClass),
      defaultEquipmentType: valueToNumber(data.defaultEquipmentType),
      defaultFobCode: valueToString(data.defaultFobCode),
      defaultFreightClass: valueToString(data.defaultFreightClass),
      defaultHazmat: data.defaultHazmat,
      defaultHeight: valueToString(data.defaultHeight),
      defaultIncoTerm: valueToString(data.defaultIncoTerm),
      defaultLen: valueToString(data.defaultLen),
      defaultPackageUom: valueToString(data.defaultPackageUom),
      defaultProdDesc: valueToString(data.defaultProdDesc),
      defaultProductCode: valueToString(data.defaultProductCode),
      defaultRatingPreferencevalue: valueToString(data.defaultRatingPreferencevalue),
      defaultShipmentTerms: valueToString(data.defaultShipmentTerms),
      defaultShipmentType: valueToString(data.defaultShipmentType),
      defaultSpotBidEndStatus:
        !data.defaultSpotBidEndStatus || data.defaultSpotBidEndStatus === ''
          ? ' '
          : valueToString(data.defaultSpotBidEndStatus),
      defaultUom: valueToString(data.defaultUom),
      defaultWidth: valueToString(data.defaultWidth),
      disableExpiredBids: data.disableExpiredBids,
      displayPO_SOOnShipmentLevel: data.displayPO_SOOnShipmentLevel,
      earlyShipmentRestrictionDetails: formatCargoTypeRestrictions(data.earlyShipmentRestrictionDetails || []),
      emailFrom: valueToString(data.emailFrom),
      enableMasterOrders: data.enableMasterOrders,
      isBillToVisible: data.isBillToVisible,
      isCategoryToValidate: data.isCategoryToValidate,
      isCategoryVisible: data.isCategoryVisible,
      isDefaultRatingPreference: data.isDefaultRatingPreference,
      isRequiredApprovalNumber: data.isRequiredApprovalNumber,
      isReverseAuction: data.isReverseAuction,
      isShowRatingDetails: data.isShowRatingDetails,
      isVendorVisible: data.isVendorVisible,
      isvisiablePaidBy: data.isvisiablePaidBy,
      isWeightCalculation: data.isWeightCalculation,
      maxBidHours: valueToNumber(data.maxBidHours),
      maximumDays: valueToNumber(data.maximumDays),
      maximumDaysErrorMsg: valueToString(data.maximumDaysErrorMsg),
      minimumDays: valueToNumber(data.minimumDays),
      minimumDaysErrorMsg: valueToString(data.minimumDaysErrorMsg),
      nextID: valueToNumber(data.nextID),
      numberOfRoutingCarrierReturned: valueToNumber(data.numberOfRoutingCarrierReturned),
      poValidationFlag: data.poValidationFlag,
      povDestinationMethod: data.poValidationFlag === 'Y' ? valueToString(data.povDestinationMethod) : ' ',
      pricingType: valueToString(data.pricingType) !== '' ? valueToString(data.pricingType) : ' ',
      qtyTolerancePercentage: valueToNumber(data.qtyTolerancePercentage),
      recalculateFreightClass: data.recalculateFreightClass === 'Y' ? 1 : 0,
      routingMethod: valueToString(data.routingMethod),
      shipmentApprovalCount: valueToNumber(data.shipmentApprovalCount),
      shipmentApprovalRequired: data.shipmentApprovalRequired,
      shipmentEmailAttachment: data.shipmentEmailAttachment,
      shipmentIdAlphaPrefix: valueToString(data.shipmentIdAlphaPrefix),
      shipmentIdStartingInteger: valueToNumber(data.shipmentIdStartingInteger),
      shipmentSupportMail: valueToString(data.shipmentSupportMail),
      shipmentTermsAllowed: valueToString(data.shipmentTermsAllowed),
      statusInTMS: data.statusInTMS || null,
    };

    return newSettings;
  }
  return data;
};
